// extracted by mini-css-extract-plugin
module.exports =  {"portrait":"portrait_hhkOd100","landscape":"landscape_SWkc93Xw","dashboard":"dashboard_HznPl0FS"};